import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { PageLoader } from "components/Loaders";
import AuthLayout from "layouts/AuthLayout";
import PrivateRoute from "routes/utils/PrivateRoute";
import AuthRoute from "routes/utils/AuthRoute";
import Error404 from "components/Error404";
// import RoleMaps from "./Routes.map";
import DashboardLayout from "layouts/DashboardLayout";
import history from "utils/history";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
// create Loadable pages
const Login = lazy(() => import("pages/auth/Login"));
const Dashboard = lazy(() => import("pages/dashboard/index"));

const CasePage = lazy(() => import("pages/cases/table"));
const CreateCase = lazy(() => import("pages/cases/create"));
const CaseDetails = lazy(() => import("pages/cases/case_details"));
const CaseEdit = lazy(() => import("pages/cases/case_edit"));

const CreateSubjectMatter = lazy(() => import("pages/subject_matter/create"));
const CreateHeadnote = lazy(() => import("pages/head_notes/create"));
const CreateRatioDecidendi = lazy(() => import("pages/ratio_decidendi/create"));

const HeadnoteTable = lazy(() => import("pages/head_notes/table"));
const SubjectMatterTable = lazy(() => import("pages/subject_matter/Table"));
const JudgmentTable = lazy(() => import("pages/Judgments/table"));
const RatioDecidendiTable = lazy(() => import("pages/ratio_decidendi/table"));

const JusticeTable = lazy(() => import("pages/justices/table"));
const CreateJustice = lazy(() => import("pages/justices/create"));
const EditJustice = lazy(() => import("pages/justices/edit"));

const EditSubjectMatter = lazy(() => import("pages/subject_matter/edit"));
const EditHeadNote = lazy(() => import("pages/head_notes/edit"));
const EditRatioDecidendis = lazy(() => import("pages/ratio_decidendi/edit"));
const EditJudgements = lazy(() => import("pages/Judgments/edit"));

const AddHeadnote = lazy(() => import("pages/head_notes/add"));
const AddRatios = lazy(() => import("pages/ratio_decidendi/add"));
const AddJudgments = lazy(() => import("pages/Judgments/add"));
const AddSubjectMatter = lazy(() => import("pages/subject_matter/add"));

const SearchResult = lazy(() => import("pages/search"));

// const Constitution = lazy(() => import('pages/constitution/Constitution'));
// const Chapters = lazy(() => import('pages/constitution/Chapters'));

export default function Routes() {
  return (
    <React.Fragment>
      <Router basename={process.env.PUBLIC_URL} history={history}>
        <Suspense fallback={<PageLoader />}>
          {/* <AlertWrapper ref={alertRef => (window.alertRef = alertRef)} /> */}
          <Switch>
            <AuthRoute
              exact={true}
              path="/"
              component={Login}
              layout={AuthLayout}
            />
            <PrivateRoute
              path="/app"
              component={Dashboard}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              exact
              path="/search"
              component={SearchResult}
              layout={DashboardLayout}
            />

            <PrivateRoute
              path="/case"
              component={CasePage}
              layout={DashboardLayout}
              exact={true}
            />
            {/* <PrivateRoute
                            path="/constitution"
                            component={Constitution}
                            layout={DashboardLayout}
                            exact={true}
                        />
                        <PrivateRoute
                            path="/chapters"
                            component={Chapters}
                            layout={DashboardLayout}
                            exact={true}
                        /> */}
            <PrivateRoute
              path="/create-case"
              component={CreateCase}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/create-subject-matter"
              component={CreateSubjectMatter}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/create-headnote"
              component={CreateHeadnote}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/create-ratioDecideni"
              component={CreateRatioDecidendi}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/create-justice"
              component={CreateJustice}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/case/:id"
              component={CaseDetails}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/case/:id/edit"
              component={CaseEdit}
              layout={DashboardLayout}
              exact={true}
            />

            <PrivateRoute
              path="/subject-matter/:id/edit"
              component={EditSubjectMatter}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/head_notes/:id/edit"
              component={EditHeadNote}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/:id/ratio-decidendis/add"
              component={AddRatios}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/:id/headnotes/add"
              component={AddHeadnote}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/:id/Judgments/add"
              component={AddJudgments}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/:id/subject_matter/add"
              component={AddSubjectMatter}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/ratio-decidendis/:id/edit"
              component={EditRatioDecidendis}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/judgements/:id/edit"
              component={EditJudgements}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/justices/:name/edit"
              component={EditJustice}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/:id?/headnotes"
              component={HeadnoteTable}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/justices"
              component={JusticeTable}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/:id?/subject-matter"
              component={SubjectMatterTable}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/:id/judgments"
              component={JudgmentTable}
              layout={DashboardLayout}
              exact={true}
            />
            <PrivateRoute
              path="/:id?/ratio-decidendis"
              component={RatioDecidendiTable}
              layout={DashboardLayout}
              exact={true}
            />

            {/* 404 Handling */}
            <Route component={Error404} />
            <Route path="/404" component={Error404} history={history} />
          </Switch>
        </Suspense>
      </Router>
      <ToastContainer />
    </React.Fragment>
  );
}
